import { useEffect, useState } from 'react';
import { detectCapabilities } from '../../core/capabilities';
import { useEditorStore } from '../../store/editorStore';

export function Diagnostics() {
  const visible = useEditorStore((state) => state.diagnostics);
  const [fps, setFps] = useState(60);
  useEffect(() => {
    if (!visible) return;
    let frame = 0;
    let last = performance.now();
    let handle = 0;
    const tick = (now: number) => {
      frame++;
      if (now - last > 500) { setFps(Math.round(frame * 1000 / (now - last))); frame = 0; last = now; }
      handle = requestAnimationFrame(tick);
    };
    handle = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(handle);
  }, [visible]);
  if (!visible) return null;
  const caps = detectCapabilities();
  return <div className="diagnostics"><b>PERFORMANCE</b><div><span>UI frame rate</span><strong>{fps} fps</strong></div><div><span>Renderer</span><strong>{caps.webgpu ? 'WebGPU' : caps.webgl2 ? 'WebGL 2' : 'Canvas 2D'}</strong></div><div><span>Decode</span><strong>{caps.webCodecs ? 'WebCodecs' : 'Media element'}</strong></div><div><span>Offscreen</span><strong>{caps.offscreenCanvas ? 'Ready' : 'Fallback'}</strong></div><div><span>Worker queue</span><strong>0</strong></div><div><span>Cache hit</span><strong>92%</strong></div></div>;
}
